"use client";

import Link from "next/link";

// Next.js otherwise scrolls the changed page-content segment into view, which on
// the home layout skips past the banner/header and makes the page appear to jump
// down. `scroll={false}` disables that, and we land at the true top of the page.
export default function HomeLink({ className, onClick, children }) {
    const handleClick = (event) => {
        window.scrollTo({ top: 0, left: 0 });
        onClick?.(event);
    };

    return (
        <Link href="/" scroll={false} onClick={handleClick} className={className}>
            {children}
        </Link>
    );
}
